import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './auth';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return next(req).pipe(catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
            authService.logoutApi().subscribe({
                next: () => {
                    authService.logout();
                    router.navigate(['/login']);
                },
                error: (err) => {
                    authService.logout();
                    router.navigate(['/login']);
                }
            });

        }
        return throwError(() => error);
    }));
};
